import {
  isThereAnyContactWhoIsCompanyOrSelfEmployed,
  areAllContactsCompanies
} from '__core/shared/util/salestrekker';
import template from './incomes.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    income: '<',
    contacts: '<',
    workflow: '<',
    assets: '<',
    homeLoanSecurities: '<',
    idTicket: '<',
    validationErrors: '<',
    isDealOwnerBroker: '<',
    haveLendersExisting: '<',
    showNetIncome: '<',
    isTicketSettled: '<',
    isContactIncome: '<',
    onFinished: '&',
    onValidated: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $mdUtil,
      $timeout,
      eventService,
      incomeService,
      helperService,
      assetsService,
      homeLoanService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
      ctrl.organizationCountry = '';
      ctrl.availableIncomeTypes = [];
      ctrl.existingInvestmentProperties = [];
      ctrl.existingOwnerOccupiedProperties = [];
      ctrl.incomeEstimate = [];
      ctrl.isProcessing = false;
      ctrl.currentlyNotShowing = true;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableIncomeTypes = incomeService.getAvailableIncomeTypes();
        ctrl.income = ctrl.income || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.assets = ctrl.assets || [];
        ctrl.homeLoanSecurities = ctrl.homeLoanSecurities || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.haveLendersExisting = ctrl.haveLendersExisting || false;
        ctrl.showNetIncome = ctrl.showNetIncome || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isContactIncome = ctrl.isContactIncome || false;
        ctrl.idItem = ctrl.idTicket || ctrl.contacts[0]?.id || '';
        ctrl.setExistingInvestmentProperties();
        if (ctrl.organizationCountry.cca2 === 'NZ') {
          ctrl.setExistingOwnerOccupiedProperties();
        }
        ctrl.getIncomeEstimate();
        ctrl.isReady = true;
      };

      ctrl.incomeAdd = (incomeType) => {
        const idContact = ctrl.isContactIncome ? ctrl.contacts[0]?.id || null : null;
        incomeService.incomeAdd(ctrl.income, incomeType, idContact, null);
        ctrl.onValidated();
      };

      ctrl.incomeDelete = (income) => {
        const idx = helperService.findIndexById(ctrl.income, income.id);
        if (idx > -1) {
          ctrl.income = incomeService.incomeDelete(ctrl.income, idx);
          ctrl.saveIncome();
        }
      };

      ctrl.isAssetFinanceOrCommercialLoan = () =>
        ctrl.workflow?.isAssetFinance() || ctrl.workflow?.isCommercialLoan();

      ctrl.isThereAnyContactWhoIsCompanyOrSelfEmployed = () =>
        isThereAnyContactWhoIsCompanyOrSelfEmployed(ctrl.contacts);

      ctrl.areAllContactsCompanies = () => areAllContactsCompanies(ctrl.contacts);

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.setExistingInvestmentProperties = () => {
        ctrl.existingInvestmentProperties = helperService.getInvestmentAssets({
          assets: ctrl.assets
        });
      };

      ctrl.setExistingOwnerOccupiedProperties = () => {
        ctrl.existingOwnerOccupiedProperties = helperService.getOwnerOccupiedAssets({
          assets: ctrl.assets
        });
      };

      ctrl.getMonthlyRentalOrBoarderIncomeByContact = (monthlyRentalIncome, percent) =>
        helperService.isNumber(monthlyRentalIncome, true) *
        (helperService.isNumber(percent, false) / 100);

      ctrl.getOwnershipForNewSecurity = () =>
        helperService.getOwnershipForNewProperties(ctrl.contacts);

      ctrl.totalIncomeByContact = ({ idContact, path, type }) => {
        const totalIncome = _.find(ctrl.incomeEstimate, (i) => i?.idContact === idContact);
        if (totalIncome) {
          if (type === 'payg') {
            return totalIncome?.totalPaygIncome[path] || 0;
          }
          if (type === 'business') {
            return totalIncome?.totalBusinessIncome[path] || 0;
          }
          return totalIncome[path] || 0;
        }
        return 0;
      };

      ctrl.getIncomeEstimate = () => {
        if (
          ctrl.income?.length ||
          ctrl.existingInvestmentProperties?.length ||
          (ctrl.organizationCountry?.cca2 === 'NZ' &&
            ctrl.existingOwnerOccupiedProperties?.length)
        ) {
          ctrl.isProcessing = true;
          financesService
            .getIncome({
              id: ctrl.idItem,
              type: ctrl.idTicket ? 'ticket' : 'contact',
              financialPositionType: 'CURRENT'
            })
            .then((res) => {
              if (res?.status) {
                ctrl.incomeEstimate = res?.income || [];
              }
              ctrl.isProcessing = false;
            });
        }
      };

      ctrl.saveIncome = _.debounce((income) => {
        if (income) {
          const idx = helperService.findIndexById(ctrl.income, income.id);
          if (idx > -1) {
            ctrl.income.splice(idx, 1);
            ctrl.income.splice(idx, 0, income);
          } else {
            ctrl.income.push(income);
          }
        }
        const data = {
          income: ctrl.income,
          tCD: 'income'
        };
        ctrl.onFinished({ data });
      }, 3000);

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'income') {
          ctrl.getIncomeEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
